import * as _downloadjs from 'downloadjs';

export const downloadjs = _downloadjs;
